"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockLogger = void 0;
const Log = __importStar(require("../Log"));
const TestAssertSink_1 = require("./TestAssertSink");
/**
 * Utility for wrapping up usage of a TestAssertSink.
 *
 * Instead of using spyOn on Log statements, you can use mockLogger to specify
 * a maximum allowed LogLevel in your test, and it will handle raising an error
 * if the maximumLevel is exceeded, and for all other log it will store them on
 * the returned object. This allows you to write assertions against log data
 * instead of spying on function calls.
 *
 * e.g.
 *
 * describe("tests with Logs in them", () => {
 *
 *   test("should not receive Log.errors", () => {
 *     const logs = mockLogger({maximumLevel: "warn"});
 *     // "warn" is the default maximumLevel so you can just write
 *     // const logs = mockLogger();
 *
 *     ... write your test code as normal, a Log.error will raise an exception
 *
 *     // you can still assert against other, lower log levels
 *     const infoLogs = logs.entries.info;
 *     expect(infoLogs).toHaveLength(2)
 *     expect(infoLogs[0].message).toEqual("The first info message");
 *     expect(infoLogs[1].message).toEqual("The second info message");
 *   });
 *
 *   test("should expect some Log.errors that I want to validate", () => {
 *     // allow Log.errors to happen without blowing up the test
 *     const logs = mockLogger({maximumLevel: "error"});
 *
 *     ... write your test code as normal
 *
 *     const errorLogs = logs.entries.error;
 *     expect(errorLogs).toHaveLength(1);
 *     expect(errorLogs[0].message).toEqual("The error message");
 *   });
 * });
 *
 * Happy testing!
 */
const mockLogger = (maxLevel = { maximumLevel: "warn" }) => {
    Log.removeAllSinks();
    const testSink = new TestAssertSink_1.TestAssertSink(maxLevel);
    Log.addSink(testSink);
    return testSink.entries;
};
exports.mockLogger = mockLogger;
//# sourceMappingURL=mockLogger.js.map